module.exports = __webpack_public_path__ + "hotels-fav-icon.png?6464c959862e975b317d289c5bfcdbf4";